// import { Polar, ServerSandbox } from "@polar-sh/sdk";


// const polar_access_token = process.env.VUE_APP_POLAR_ACCESS_TOKEN_PORTAL;

// if (!polar_access_token) {
    
//   throw new Error("Polar access token is missing!");
// }

// console.log(polar_access_token)

// export const polarClient = new Polar({
//   server: "sandbox",
//   accessToken: polar_access_token ?? "",

// });


//CHANGE SERVERS BEFORE GOING LIVE!! MAKE IT GO TO PRODUCTION WITH CODE BELOW!

import { Polar } from "@polar-sh/sdk";
import { ServerProduction, ServerSandbox } from "@polar-sh/sdk";

const polar_access_token = process.env.VUE_APP_POLAR_ACCESS_TOKEN_PORTAL;

if (!polar_access_token) {
  throw new Error("Polar access token is missing!");
}

export const polarClient = new Polar({
  server: process.env.NODE_ENV === 'production' ? ServerProduction : ServerSandbox,
  accessToken: polar_access_token ?? "",
});